import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { navLinks } from './constants/navigation';
import { AnalyticsService } from '../../../services/analytics.service';

import { environment } from "../../../../environments/environment";

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  navLinks = navLinks;
  isMenuOpen = false;
  isExternal = false;
  isScrolled = false; // Nueva propiedad para controlar el scroll

  constructor(private readonly router: Router, private readonly analyticsService: AnalyticsService) {}

  ngOnInit() {
    // Asegurar que el body tenga el overflow correcto al inicializar
    document.body.style.overflow = '';
  }

  ngOnDestroy() {
    // Restaurar el overflow del body al destruir el componente
    document.body.style.overflow = '';
  }

  // Listener para detectar scroll
  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    // Mostrar botones flotantes cuando el usuario haga scroll hacia abajo
    this.isScrolled = window.scrollY > 100;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    // Cerrar el menú si se hace clic fuera del navbar
    const target = event.target as HTMLElement;
    if (!target.closest('.navbar') && this.isMenuOpen) {
      this.closeMenu();
    }
  }

  isActive(link: string): boolean {
    return this.router.url === link;
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;

    // Track menu toggle
    this.analyticsService.trackButtonClick(
      this.isMenuOpen ? 'Menu Open' : 'Menu Close',
      'Navbar',
      { menu_state: this.isMenuOpen }
    );

    // Manejar el overflow del body cuando el menú está abierto
    if (this.isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  // Método para cerrar el menú cuando se navega
  closeMenu(): void {
    if (this.isMenuOpen) {
      this.isMenuOpen = false;
      document.body.style.overflow = '';
    }
  }

  getFilteredNavLinks() {
    if (this.router.url === '/auto-apertura') {
      return [];
    }
    return this.navLinks;
  }

  // Método para manejar la navegación de enlaces
  navigateToLink(link: any): void {
    // Track navigation click
    this.analyticsService.trackLinkClick(
      link.name,
      link.href,
      'Navbar',
      link.isExternal
    );

    if (link.isExternal) {
      // Para enlaces externos, abrir en nueva pestaña
      window.open(link.href, '_blank');
    } else {
      // Para enlaces internos, usar el router de Angular
      this.router.navigate([link.href]);
      this.closeMenu(); // Cerrar el menú móvil si está abierto
    }
  }

  // Método para abrir auto-apertura
  openAutoApertura(): void {
    // Track CTA click
    this.analyticsService.trackCTAClick(
      'Solicita tu Unipay aquí',
      'Navbar',
      'button',
      { url: 'https://www.unipay.cl/autoatencion-ptoventa/validar-identidad' }
    );

    window.open('https://www.unipay.cl/autoatencion-ptoventa/validar-identidad?utm_source=Digital&utm_medium=Pagina_Unipay&utm_campaign=Boton', '_self', 'noopener,noreferrer');
  }

  // Método para abrir pago de estado de cuenta
  openPagoEstadoCuenta(): void {
    // Track CTA click
    this.analyticsService.trackCTAClick(
      'Pagar Estado de Cuenta',
      'Navbar',
      'button',
      { url: environment.urlBase+'/pago' }
    );
console.log("pagar estado de cuenta 2");
    window.open(environment.urlBase+'/pago', '_blank', 'noopener,noreferrer');
  }
}
